import HotelStrategyDetailBaseRoute from 'lumen/routes/hotel/strategy/detail-base';
import { TYPE_ID_LOS } from 'lumen/utils/constants/rate-strategy-constants';

export default class HotelStrategyLosRoute extends HotelStrategyDetailBaseRoute {
  type = TYPE_ID_LOS;
}
